import { parseHref } from '@/shared/utils/href';
import { JuniorGameType } from '../store/constants';

import type { Href } from '@/shared/utils/href';
import type { GameData, Question } from '../types';

type JuniorQuestion = Partial<Question> & Pick<Question, 'question_display'>;

type JuniorGame = Omit<GameData, 'game' | 'questions'> &
	Partial<NonNullable<GameData['game']>> & {
		type: string;
		questions?: JuniorQuestion[];
	};

export type JuniorGameResponse = {
	game: JuniorGame;
	callbacks?: { session_end_href?: Href };
};

export const normalizeJuniorGameData = (response: JuniorGameResponse) => {
	const game = response?.game;
	if (!game || (game.type !== JuniorGameType.LETTER_PARTY && game.type !== JuniorGameType.TRACING)) {
		throw new Error(`Unsupported Junior game type: ${game?.type ?? 'missing'}`);
	}
	if (typeof game.title !== 'string' || (game.questions !== undefined && !Array.isArray(game.questions))) {
		throw new Error('Invalid Junior game data');
	}

	const questions = game.questions?.map(
		(question, index): Question => ({
			id: index + 1,
			ai_tutor_enabled: false,
			explanation_available: false,
			time_estimate_in_seconds: 0,
			title: game.title,
			topic_id: 0,
			topic_title: game.title,
			type: '',
			...question,
		}),
	);
	const gameData: GameData = {
		...game,
		game,
		questions,
	};
	const callback = response.callbacks?.session_end_href;
	const sessionEndHref = callback === undefined ? undefined : parseHref(callback);

	return { gameData, sessionEndHref };
};
